import { Col, Row, Skeleton } from 'ui';

const InvitationsSkeleton = () => (
  <Row className="calendar-invitations-skeleton">
    {Array.from({ length: 10 }, (_, index) => (
      <Col key={index} span={24}>
        <Skeleton active paragraph={{ rows: 2 }} />
      </Col>
    ))}
  </Row>
);

export default InvitationsSkeleton;
